
import React, {Component} from "react";

export  class FlatIcon extends Component {

    render() {
        return (
            <i className={['flaticon-' + this.props.icon, 'icon'].join(' ')}/>
        )
    }
}

export  class StrokeIcon extends Component {

    // COMPONENT Render ................................
    render() {
        return (
            <i className={['s7-' + this.props.icon, 'icon'].join(' ')}/>
        )
    }
}
